import axios from 'axios'
import router from '../router'

export default {
  install (Vue, opts = {}) {
    // let baseURL = 'https://gw.meetuvip.com';
    // let baseURL = 'http://gw.test.deepvision.link';
    const baseURL = process.env.VUE_APP_HOST

    /**
     * 全局配置文件
     */
    const http = axios.create({
      baseURL,
      timeout: 60 * 1000,
      headers: {
        // TODO 后端服务器采用的是该编码格式 后期统一转换成json格式
        // 'Content-Type':'application/json'
        // "jzToken": userInfo ? userInfo.token : ''
      }
    })

    const httpblob = axios.create({
      baseURL,
      timeout: 180 * 1000,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    })

    /**
     * 全局拦截请求
     *
     */
    http.interceptors.request.use(function (config) {
      let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
      config.headers.accessToken = userInfo.token || '';
      config.headers.clientPlatform = 3;
      config.headers.version = "v1.2.0";
      // 序列化请求参数
      // if (config.method === 'post' || config.method === 'get') config.data = qs.stringify(config.data)
      return config;
    }, function (error) {
      console.error("error:", error); // for debug
      Promise.reject(error);
    });

    httpblob.interceptors.request.use(function (config) {
      let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
      config.headers.accessToken = userInfo.token || '';
      config.headers.clientPlatform = 3;
      config.headers.version = "v1.2.0";
      // 序列化请求参数
      // if (config.method === 'post' || config.method === 'get') config.data = qs.stringify(config.data)
      return config;
    }, function (error) {
      console.error("error:", error); // for debug
      Promise.reject(error);
    });

    /**
     * 全局拦截响应
     */
    http.interceptors.response.use(function (res) {
      // let userInfo = JSON.parse(window.localStorage.getItem('userInfo') || '{}');
      let errcode = res.data.code;
      if (errcode == '00000') { // 成功
        return res; // 传数据
      } else if (errcode == '20001' || errcode == '20002' || errcode == '20003') { // 未登录
        Vue.prototype.$Notice.warning({
          type: 'warning',
          title: res.data.desc
        });
        router.replace({ path: '/login' })
      }
    }, function (error) {
      Promise.reject(error);
    });

    async function post (url, param = {}, callback) {
      const res = await http.post(url, param)
      // if (res.status === 200 && parseInt(res.data.errcode) != 0) {
      //   Vue.prototype.$Notice.warning({
      //     title: res.data.errmsg,
      //   });
      //   if (Object.prototype.toString.call(callback) === "[object Function]") return callback(res)
      //   return Promise.reject('出错了');
      // }
      return res.data
    }
    async function get (url, config = {}, callback) {
      const res = await http.get(url, config)
      return res
    }

    async function put (url, param = {}, callback) {
      const res = await http.put(url, param)
      return res
    }
    // 导出-二进制流
    async function blobpost (url, param = {}, callback) {
      const res = await httpblob.post(url, param)
      return res
    }

    async function uploadFile (url, param = {}, callback) {
      const res = await http.post(url, param, { 'Content-Type': 'multipart/form-data' })
      return res.data
    }

    Vue.prototype.$post = post
    Vue.prototype.$get = get
    Vue.prototype.$put = put
    Vue.prototype.$blobpost = blobpost
    Vue.prototype.$fullhttpUpload = uploadFile
    Vue.prototype.$fullhttp = http
    Vue.prototype.$fullhttpblob = httpblob
    window.$post = post
    window.$get = get
    window.$put = put
    window.$fullblobpost = blobpost
    window.$fullhttpUpload = uploadFile
  }
}
